<nav class="sidenav" [class.collapsed]="!isExpanded">
  <div class="sidenav-header">
    <div class="brand" style="align-items: center;">
      <div *ngIf="!isExpanded" class="brand-icon">
        <img [routerLink]="['home']" [relativeTo]="route" style="height: 50px;"
          src="../assets/images/viresco-icon.png"
          alt="Viresco ERP Educacional"/>
      </div>
      <div *ngIf="isExpanded" class="brand-logo">
        <img [routerLink]="['home']" [relativeTo]="route" style="width: 150px;"
          src="../assets/images/VIRESCO-branco.png"
          alt="Viresco ERP Educacional"/>

      </div>
      <!-- <span class="brand-text" *ngIf="isExpanded">Viresco</span> -->
      <!-- <span class="brand-subtitle" *ngIf="isExpanded">SISTEMAS ERP Educacional</span> -->
    </div>
    <!-- <button class="toggle-btn" (click)="toggleExpansion()" type="button">
      <i class="toggle-icon" [class.rotated]="!isExpanded">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </i>
    </button> -->
  </div>

  <div class="sidenav-content">
    <ul class="nav-menu">
      <li class="nav-item">
        <a [routerLink]="['matriculas']" [relativeTo]="route" class="nav-link active" [ngClass]="{'active-module': selectedModule === 0}" [title]="!isExpanded ? 'Matrículas' : ''"
          (click)="toggleModule(0)">
          <mat-icon class="nav-icon" fontSet="material-symbols-outlined">person_book</mat-icon>
          <span class="nav-text" *ngIf="isExpanded">Matrículas</span>
        </a>
      </li>
      <li class="nav-item">
        <a [routerLink]="['avaliacoes']" [relativeTo]="route" class="nav-link" [ngClass]="{'active-module': selectedModule === 1}" [title]="!isExpanded ? 'Avaliações' : ''"
          (click)="toggleModule(1)">
          <mat-icon class="nav-icon" fontSet="material-symbols-outlined">table_chart_view</mat-icon>
          <span class="nav-text" *ngIf="isExpanded">Avaliações</span>
        </a>
      </li>
      <li class="nav-item">
        <a [routerLink]="['financeiro']" [relativeTo]="route" class="nav-link" [ngClass]="{'active-module': selectedModule === 2}" [title]="!isExpanded ? 'Financeiro' : ''"
          (click)="toggleModule(2)">
          <mat-icon class="nav-icon" fontSet="material-symbols-outlined">attach_money</mat-icon>
          <span class="nav-text" *ngIf="isExpanded">Financeiro</span>
        </a>
      </li>
      <!-- Adicione mais itens de navegação conforme necessário -->
      <!-- <li class="nav-item">
        <a [routerLink]="['perfil']"  [relativeTo]="route" class="nav-link active" [ngClass]="{'active-module': selectedModule === 1}" [title]="!isExpanded ? 'Perfil' : ''"
          (click)="toggleModule(1)">
          <i class="nav-icon icon-perfil"></i>
          <span class="nav-text" *ngIf="isExpanded">Perfil</span>
        </a>
      </li> -->
    </ul>
  </div>

  <div class="sidenav-footer" *ngIf="isExpanded">
    <div class="copyright">
      © 2025 Viresco Sistemas ERP
    </div>
  </div>
</nav>
